import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Services
import { AppConfigService } from '@core/services/app-config.service';

/**
 * Miroir d'authGuard
 **/
export const guestGuard: CanActivateFn = () => {
	const appConfig = inject(AppConfigService);
	const router = inject(Router);

	return !appConfig.isLogged || router.createUrlTree(['']);
};
